import { One } from '../../icons/rebalance/One'
import { Two } from '../../icons/rebalance/Two'
import { Three } from '../../icons/rebalance/Three'
import { Four } from '../../icons/rebalance/Four'
import { Five } from '../../icons/rebalance/Five'

const NumberIcons = {
  1: One,
  2: Two,
  3: Three,
  4: Four,
  5: Five
} as const

export const NumberIcon = ({ number }: { number: number }) => {
  const IconComponent = NumberIcons[number as keyof typeof NumberIcons]
  if (IconComponent) {
    return <IconComponent />
  }

  return (
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#F0F4F7] 
    text-[18px] font-[400] text-[#3D3D3D]">
      {number}
    </div>
  )
}
